module.exports = __webpack_public_path__ + "static/media/seondfloor.a505f511.png";